import { timeToMilliseconds } from '../types';
var PingResponse = (function () {
    function PingResponse(raw) {
        if (raw.Message !== PingResponse.NAME) {
            throw new Error("Unsupported message=" + raw.Message);
        }
        if (raw.Version !== PingResponse.VERSION) {
            throw new Error("Unsupported version=" + raw.Version + " for message=" + raw.Message);
        }
        this._timeReceivedResponse = Date.now();
        this._timeAtSender = Number(timeToMilliseconds(raw.time_at_sender.microseconds));
        this._timeFromRequest = Number(timeToMilliseconds(raw.time_from_request.microseconds));
    }
    Object.defineProperty(PingResponse.prototype, "timeAtPeer", {
        get: function () {
            return this._timeAtSender;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PingResponse.prototype, "timeOfRequest", {
        get: function () {
            return this._timeFromRequest;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PingResponse.prototype, "timeOfResponse", {
        get: function () {
            return this._timeReceivedResponse;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PingResponse.prototype, "latencyTotal", {
        get: function () {
            return this._timeReceivedResponse - this._timeFromRequest;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PingResponse.prototype, "latencyAtPeer", {
        get: function () {
            return this._timeAtSender - this._timeFromRequest;
        },
        enumerable: false,
        configurable: true
    });
    PingResponse.NAME = 'Foundation::PingResponse';
    PingResponse.VERSION = 2;
    return PingResponse;
}());
export { PingResponse };
//# sourceMappingURL=PingResponse.js.map